import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
import Navbar from "../src/components/Navbar.vue";
// import { h } from 'vue';
// const wrapperMap = new Map();
// // 将router传个我们的组件重新换一个新的组件，原组件包里面
// function formatComponentInstance(component, route) {
//   let wrapper;
//   if (component) {
//     const wrapperName = route.path;
//     if (wrapperMap.has(wrapperName)) {
//       wrapper = wrapperMap.get(wrapperName);
//     } else {
//       wrapper = {
//         name: wrapperName,
//         render() {
//           return h(component);
//         },
//       };
//       wrapperMap.set(wrapperName, wrapper);
//     }
//     return h(wrapper);
//   }
// }

export default {
  __name: 'App',
  setup(__props) {
    // 导入Navbar

    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(Navbar), _createVNode(_component_router_view, {
        include: ['News', 'New']
      }, {
        default: _withCtx(({
          Component,
          route
        }) => [(_openBlock(), _createBlock(_KeepAlive, null, [route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: route.name
        })) : _createCommentVNode("", true)], 1024)), !route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: route.name
        })) : _createCommentVNode("", true)]),
        _: 1
      })]);
    };
  }
};